import { indexItems } from '@/mocks/homeData';

const colorMap: Record<string, { bg: string; text: string; border: string; hoverBg: string }> = {
  primary: {
    bg: 'bg-primary-100',
    text: 'text-primary-600',
    border: 'border-primary-200',
    hoverBg: 'hover:bg-primary-50',
  },
  accent: {
    bg: 'bg-accent-100',
    text: 'text-accent-600',
    border: 'border-accent-200',
    hoverBg: 'hover:bg-accent-50',
  },
  secondary: {
    bg: 'bg-secondary-100',
    text: 'text-secondary-700',
    border: 'border-secondary-200',
    hoverBg: 'hover:bg-secondary-50',
  },
};

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
              <i className="ri-folder-open-line"></i>
              吃瓜索引
            </div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
              吃瓜索引
            </h2>
            <p className="text-sm text-foreground-500 mt-2">按话题分类浏览，快速找到你感兴趣的爆料内容</p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-3 md:gap-4">
            {indexItems.map((item) => {
              const colors = colorMap[item.color] || colorMap.primary;
              return (
                <div
                  key={item.id}
                  className={`group bg-background-50 border ${colors.border} rounded-xl p-5 text-center ${colors.hoverBg} transition-all cursor-pointer`}
                >
                  <div className={`w-12 h-12 mx-auto rounded-xl ${colors.bg} flex items-center justify-center mb-3 group-hover:scale-110 transition-transform`}>
                    <i className={`${item.icon} text-xl ${colors.text}`}></i>
                  </div>
                  <h3 className="font-sans text-sm font-semibold text-foreground-900 mb-1.5">
                    {item.title}
                  </h3>
                  <div className="text-xs text-foreground-400">
                    {item.count}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}